import './CandyQr.sass';

import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { Button, Header, Placeholder, ScrollView } from '$uikit';
import { Link } from 'react-router5';
import { FEED, PROFILE, RESOLVE, SUBSCRIPTION_ADULT } from '$shared/constants/pages';
import { IcCheck28, IcSuccess72 } from '$assets';
import { balanceActions } from '$store/balance';
import { BalancePayAction } from '$store/balancePay/interface';
import { SubscriptionType } from '$store/models';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslator } from '$hooks';
import { goTo } from '$navigation/helper';
import { mainSelector } from '$store/main';
import { setStorageItem, statReachGoal } from '$utils';
import { ContentPriorityType } from '$store/main/interface';
import { PROMO_MODELS } from '$shared/constants';

export const CandyQr: FC = () => {
  const dispatch = useDispatch();
  const ref = useRef<any>(null);
  const t = useTranslator();
  const { decryptKeys } = useSelector(mainSelector);
  const hasSubscription = !!decryptKeys[-1];
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => {
    statReachGoal('candy_qr');
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      if (ref.current) {
        ref.current.scrollBy({
          left: 112 + 8 + (ref.current.scrollLeft ? 0 : 16),
          top: 0,
          behavior: 'smooth',
        });
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [scrollLeft]);

  const handleScroll = useCallback(({ target }) => {
    setScrollLeft(target.scrollLeft);
  }, []);

  useEffect(() => {
    hasSubscription && goTo(SUBSCRIPTION_ADULT);
  }, [hasSubscription]);

  const handlePay = useCallback(() => {
    statReachGoal('candy_qr_pay_button');
    setStorageItem('contentPriorityType', ContentPriorityType.ADULT);
    dispatch(
      balanceActions.pay({
        amount: 1,
        action: BalancePayAction.QR_BONUS,
        objectId: SubscriptionType.Adult,
        extraId: 1,
        period: 1,
      }),
    );
  }, []);

  return (
    <>
      <Header>{t('candy_qr_header')}</Header>
      <ScrollView
        className="CandyQr"
        footer={
          !hasSubscription && (
            <Button onClick={handlePay}>{t('candy_qr_pay_button')}</Button>
          )
        }
      >
        <div className="CandyQr__wrapper">
          <div className="CandyQr__cont">
            <div className="CandyQr__models__wrap">
              <div className="CandyQr__models" ref={ref} onScroll={handleScroll}>
                {PROMO_MODELS.map((item, i) => (
                  <Link
                    routeName={item.domain ? RESOLVE : PROFILE}
                    routeParams={item.domain ? { domain: item.domain } : { id: item.id }}
                    className="CandyQr__model"
                    key={i}
                    style={{ backgroundImage: `url(${item.avatar})` }}
                  >
                    <div className="CandyQr__model__name">{item.name}</div>
                  </Link>
                ))}
              </div>
            </div>
            <div className="CandyQr__text">
              <div className="CandyQr__text__title">{t('candy_qr_title')}</div>
              <div className="CandyQr__text__description">{t('candy_qr_desc')}</div>
            </div>
            <div className="CandyQr__advantages">
              {[
                t('candy_qr_advantage_1'),
                t('candy_qr_advantage_2'),
                t('candy_qr_advantage_3'),
                t('candy_qr_advantage_4'),
              ].map((item) => (
                <div key={item} className="CandyQr__advantages__item">
                  <IcCheck28 />
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </ScrollView>
    </>
  );
};
